import { ConcreteStrengthCertificateType } from "@store/graphql/helpers/types.graphql";
import { useAtom, atom } from "@libraries/jotai";

const certificatesAtom = atom<ConcreteStrengthCertificateType[]>([]);
const filteredCertificatesAtom = atom<ConcreteStrengthCertificateType[]>([]);

export default function useCertificates() {
  const [value, setValue] = useAtom(certificatesAtom);
  const [filteredCertificates, setFilteredCertificates] = useAtom(
    filteredCertificatesAtom
  );

  return { value, setValue, filteredCertificates, setFilteredCertificates };
}
